import * as React from "react";
import { Router, Route, Switch } from "react-router-dom";

import { Login } from "src/modules/login";
import { Portal } from "src/modules/portal";
import { observer } from "mobx-react";
import { computed } from "mobx";

import { authStore } from "src/modules/auth";
import { PortalAppBar } from "src/components/app-bar";
import { AppRedirect } from "src/modules/apps";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";
import { history } from "src/history.js";
import PasswordReset from './../modules/portal/PasswordReset';

/**
 * Render the welcome/login page initially.
 *
 * The welcome/login page provides a link to enter the app. The app's title and side bar
 * are static while the main content is rendered based on the url path governed by react-router-dom.
 */

@observer
class UnstyledApplicationRouter extends React.Component {
  constructor(props: any) {
    super(props);
  }
  @computed
  public get loggedin(): boolean {
    return !!authStore.currentUser.SessionKey;
  }

  public render() {
    if (!this.loggedin) {

      return (
        <Router history={history}>
          <Switch>
            <Route path="/password-reset/:token" component={PasswordReset} />
            <Route path="/" component={Login} />
          </Switch>
        </Router>
      )


    } else {
      return (
        <Router history={history}>
          <Switch>
            <Route path="/login/:app" component={AppRedirect} />
            <Route path="/" component={Portal} />
          </Switch>
        </Router>
      );
    }
  }
}

export const ApplicationRouter = UnstyledApplicationRouter;



// WEBPACK FOOTER //
// ./src/router/ApplicationRouter.tsx